import React from "react";
import { listingTypeData } from "../../../../data/category/inputData";
import CheckboxFilter from "../Common/CheckboxFilter";

const ListingType = () => {
  return (
    <CheckboxFilter
      title="Listing Type"
      filterData={listingTypeData}
      filterName="listingType"
    />
  );
};

export default ListingType;
